import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_there_cases_where_trash_debris_or_empty_containers_have_acc'

export const dataPointDefinition = {
  retracedId: 'are_there_cases_where_trash_debris_or_empty_containers_have_acc',
  name: 'Are there cases where trash, debris, or empty containers have accumulated to the point where they pose a safety hazard or obstruct exits?',
  description: '',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-4--5',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 13510,
  sectionId: '2.2.9.5',
  impactArea: 'Chemicals and Hazardous Substances',
  impactAreaId: 'CHEMICALS_AND_HAZARDOUS_SUBSTANCES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
